import {Button, Grid, Switch, TextField, Theme, Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import {makeStyles} from '@material-ui/styles';
import React, {useEffect, useState} from 'react';
import {getHandleFieldChange} from '../../../utils/formHelpers';
import {formatGraphQlDate} from '../../../utils/formatters';

const useStyles = makeStyles((theme: Theme) => ({
    root: {},
    content: {
        padding: theme.spacing(0, 3),
        flexGrow: 1
    },
    contentSection: {
        padding: theme.spacing(2, 0)
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    fieldGroup: {
        display: 'flex',
        alignItems: 'center'
    },
    field: {
        marginTop: 0,
        marginBottom: 0
    },
    flexGrow: {
        flexGrow: 1
    },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  radioGroup: {},
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));

export interface FilterValues {
    id?: number
    start_date?: Date | string,
    end_date?: Date | string,
    disabled_true: boolean,
    disabled_false: boolean,
}

export const SearchFilter = (props: { applyFilters: (filters: FilterValues) => void, filters: FilterValues, initialFilters: FilterValues }) => {
  const {filters, initialFilters} = props;
  const classes = useStyles();
  const [formState, setFormState] = useState({...filters});
  useEffect(() => {
    setFormState(props.filters)
  }, [props.filters]);

  const handleClear = () => {
    props.applyFilters(initialFilters);
  };

  const handleFieldChange = getHandleFieldChange(setFormState);

  const applyFilters = () => {
    props.applyFilters(formState);
  };
  return (
    <React.Fragment>
        <div className={classes.content}>
            <div className={classes.contentSection}>

                <Grid item xs={12}>
                    <Typography component="p" gutterBottom variant="overline">
                        Date Range
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item md={6}>
                            <TextField
                                className={classes.field}
                                defaultValue={formState.start_date ? formatGraphQlDate(formState.start_date) : ''}
                                fullWidth
                                label="Start date"
                                name="start_date"
                                onChange={handleFieldChange}
                                type="date"
                                InputLabelProps={{shrink: true}}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item md={6}>
                            <TextField
                                className={classes.field}
                                defaultValue={formState.end_date ? formatGraphQlDate(formState.end_date) : ''}
                                fullWidth
                                label="End date"
                                name="end_date"
                                onChange={handleFieldChange}
                                type="date"
                                InputLabelProps={{shrink: true}}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid component="label" container alignItems="center" spacing={1}>
                        <Grid item xs={4}><Typography variant="h5">Disabled?</Typography></Grid>
                        <Grid item><Typography variant="h5">Yes</Typography></Grid>
                        <Grid item>
                            <Switch
                                checked={formState.disabled_true}
                                color="secondary"
                                edge="start"
                                name="disabled_true"
                                onChange={handleFieldChange}
                                value={formState.disabled_true}
                            />
                        </Grid>
                        <Grid item><Typography variant="h5">No</Typography></Grid>
                        <Grid item>
                            <Switch
                                checked={formState.disabled_false}
                                color="secondary"
                                edge="start"
                                name="disabled_false"
                                onChange={handleFieldChange}
                                value={formState.disabled_false}
                            />
                        </Grid>
                    </Grid>
                </Grid>

            </div>
        </div>
        <div className={classes.actions}>
          <Button id="clear" fullWidth onClick={handleClear} variant="contained">
            <DeleteIcon className={classes.buttonIcon}/>
            Clear
          </Button>
          <Button id="submit" color="primary" fullWidth variant="contained" onClick={applyFilters}>
            Apply filters
          </Button>
        </div>
    </React.Fragment>
  );
};

export default SearchFilter;